import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {UsersSearchForm} from 'features/user-admin/types';
import {Observable} from 'rxjs';
import {catchError} from 'rxjs';
import {ErrorHandlerService} from 'services/error-handler.service';
import {User} from 'shared/models/User';
import {SuccessApiDto} from './types/success-api.dto';
import {ApiRoutes} from 'core/enums/api.routes';
import {ExportColsFormat} from 'shared/export-cols.prepper';
import {EXPORT_FORMAT} from 'shared/types/ExportFormat';

@Injectable({
  providedIn: 'root',
})
export class UsersService {
  constructor(
    private readonly http: HttpClient,
    private readonly errorHandlerService: ErrorHandlerService,
  ) {
  }

  users(
    {page = 1, limit = 20}: { page?: number; limit?: number },
    filters: UsersSearchForm['filters'] = {},
  ): Observable<SuccessApiDto<User[]>> {
    return this.http
      .post<SuccessApiDto<User[]>>(ApiRoutes.POST_FILTER_USERS, filters, {
        params: {page, limit},
      })
      .pipe(catchError(this.errorHandlerService.handleError));
  }

  getUserValues(filters: UsersSearchForm['filters'] = {}) {
    return this.http
      .post<SuccessApiDto<User[]>>(ApiRoutes.POST_FILTER_USERS, filters)
      .pipe(catchError(this.errorHandlerService.handleError));
  }

  export(filters: {
    filters: UsersSearchForm['filters'];
    columns: ExportColsFormat[];
    exportFormat: EXPORT_FORMAT;
  }) {
    return this.http.put(ApiRoutes.PUT_USERS_EXPORT, filters);
  }
}
